/**
 * Authentication service for user-side auth operations.
 * Uses axios instance (cookie-based auth).
 */
import api from '../api/axiosInstance';
import { AUTH_ENDPOINTS } from '../constants/apiConstants';

/**
 * Check current login status.
 * @returns {Promise<{authenticated: boolean, user: object|null}>}
 */
export const checkLoginStatus = () => {
  return api.get(AUTH_ENDPOINTS.LOGIN_STATUS);
};

/**
 * Login with email/password.
 * @param {string} email
 * @param {string} password
 * @param {boolean} remember
 * @returns {Promise<{data: {user: object, message: string}}>}
 */
export const loginTraditional = (email, password, remember) => {
  return api.post(AUTH_ENDPOINTS.LOGIN, { email, password, remember });
};

/**
 * Register a new user.
 * @param {object} userData - { name, email, password, confirm_password }
 * @returns {Promise<{data: {user: object, message: string}}>}
 */
export const registerUser = (userData) => {
  return api.post(AUTH_ENDPOINTS.REGISTER, userData);
};

/**
 * Logout current user.
 * @returns {Promise}
 */
export const logoutUser = () => {
  return api.post(AUTH_ENDPOINTS.LOGOUT);
};
